/* eslint-disable class-methods-use-this */
import React from 'react';
import BaseClass from 'components/BaseClass';
import PropTypes from 'prop-types';
import { colors } from 'style/config';
import { Box, Text, Link } from 'components/ui';
import { wrapComponent } from 'utils/framework';
import localeUtils from 'utils/LanguageLocale';
import CallUsEN from 'components/Content/CustomerService/CallUs/locales/CallUs_en_US';
import CallUsFR from 'components/Content/CustomerService/CallUs/locales/CallUs_fr_CA';

const getText = localeUtils.getLocalisedDataFromResource(CallUsEN, CallUsFR);

/**
 * Customer Service contact-strip tile that surfaces Sephora's phone support: the main
 * line (1-877-SEPHORA) and the Deaf/Hard-of-Hearing accessibility link, plus availability
 * hours. Driven by the CMS `CS_callUs` rendering type.
 *
 * NOTE (ECSC-9550): The Rouge Private Hotline (1-855-55-ROUGE) was intentionally and
 * permanently removed from this tile, along with the `vibSegment` Redux wiring that gated
 * it. Do not reintroduce the Rouge-specific messaging without a new business requirement.
 *
 * @param {Object} props
 * @param {string} props.sid - CMS-provided id applied to the tile's root element.
 * @param {Array|number} [props.marginBottom] - Responsive bottom spacing for the tile.
 * @param {Array|string} [props.gridColumn] - Grid column span; set by LayoutCs so the
 *   contact tiles render as equal-width columns.
 */
class CallUs extends BaseClass {
    constructor(props) {
        super(props);
    }

    render() {
        const { sid, marginBottom, gridColumn } = this.props;

        return (
            <Box
                id={sid}
                backgroundColor={colors.nearWhite}
                gridColumn={gridColumn}
                borderRadius={2}
                padding={[4, 5]}
                marginBottom={marginBottom}
            >
                <Text
                    is='h2'
                    fontWeight={'bold'}
                    children={getText('callUs')}
                    fontSize='xl-bg'
                    marginBottom={1}
                />
                <div>
                    <Box marginBottom={3}>
                        <div>
                            <Link
                                href={'tel:1-877-737-4672'}
                                color={colors.blue}
                            >
                                <Text fontSize='md'>{getText('phone')}</Text>
                            </Link>{' '}
                            <Text fontSize='md'>{getText('phoneLocation')}</Text>{' '}
                        </div>
                        <div>
                            <Text fontSize='md'>{getText('hearingImpaired')}</Text>{' '}
                            <Link
                                href={'tel:1-888-866-9845'}
                                color={colors.blue}
                            >
                                <Text fontSize='md'>{getText('hearingImpairedPhone')}</Text>
                            </Link>{' '}
                        </div>
                    </Box>
                    <Text fontSize='md'>{getText('representative')}</Text>
                    <br />
                    <Text
                        fontSize='md'
                        fontWeight={'bold'}
                    >
                        {getText('monFri')}:{' '}
                    </Text>
                    <Text fontSize='md'>{getText('monFriTime')}</Text> <br />
                    <Text
                        fontSize='md'
                        fontWeight={'bold'}
                    >
                        {getText('satSun')}:{' '}
                    </Text>
                    <Text fontSize='md'>{getText('satSunTime')}</Text>{' '}
                </div>
            </Box>
        );
    }
}

CallUs.propTypes = {
    sid: PropTypes.string.isRequired,
    marginBottom: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
    gridColumn: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
};

export default wrapComponent(CallUs, 'CallUs', true);
